import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics, trackWebVital } from './utils/analytics';

// Initialize Google Analytics
initializeAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Send Core Web Vitals to Google Analytics
// Tracks: CLS, INP (replaces deprecated FID), FCP, LCP, TTFB
reportWebVitals(trackWebVital);
